import { ApiRoutes } from "./apiRoutes";
import RestService from "./RestService";

export const EmailVerificationService = {
  async sendEmailVerification(url: string) {
    const payload = { url };
    return RestService.post(ApiRoutes.EMAIL_VERIFICATION, payload);
  },
};
